import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPlayFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.5 8C13.5004 8.1567 13.4588 8.31083 13.3794 8.44741C13.2999 8.58398 13.1853 8.69835 13.0466 8.77939L4.45091 13.8641C4.30599 13.95 4.14001 13.9968 3.9701 13.9998C3.8002 14.0029 3.63254 13.962 3.48443 13.8814C3.33774 13.8021 3.21553 13.6865 3.13039 13.5463C3.04525 13.4062 3.00025 13.2467 3 13.0842V2.91582C3.00025 2.7533 3.04525 2.59378 3.13039 2.45365C3.21553 2.31353 3.33774 2.19786 3.48443 2.11855C3.63254 2.03799 3.8002 1.99712 3.9701 2.00016C4.14001 2.0032 4.30599 2.05005 4.45091 2.13586L13.0466 7.22061C13.1853 7.30165 13.2999 7.41602 13.3794 7.55259C13.4588 7.68917 13.5004 7.8433 13.5 8Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgPlayFilled)
const IconSvgPlayFilled = createIcon(ForwardRef, 'SvgPlayFilled')
export default IconSvgPlayFilled
